import React, { useState } from 'react';
import IconChevronDown from '../../svg/IconChevronDown';
import PageSizeOptionList from './PageSizeOptionList';

const pageSizeLabel = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14
};
const pageSizeText = {
    ...pageSizeLabel,
    fontWeight: 'bold',
    color: '#414141',
    marginLeft: 7
};
const pageSizeTextHighlight = {
    ...pageSizeText,
    color: '#FD9A00'
};
const pageSizeIcon = {
    width: 18,
    height: 20,
    verticalAlign: 'middle',
    marginLeft: 10
};
const pageSizeIconActive = {
    fill: '#414141',
    cursor: 'pointer',
    ...pageSizeIcon
};
const pageSizeIconInactive = {
    fill: '#D1D1D1',
    cursor: 'auto',
    ...pageSizeIcon
};

const PageSizeSelect = ({ pageInfo, onPageSizeChange, invert }) => {
    const [showPageSizeOptionList, setShowPageSizeOptionList] = useState(false);

    const getPageSizeText = (val) => {
        if (!pageInfo.pageSizeOptions || pageInfo.pageSizeOptions.length === 0)
            return '';

        const any = pageInfo.pageSizeOptions.find((o) => o.value === val);
        if (!any) return '';

        return any.text;
    };

    const handleClickDropdownButton = () => {
        if (pageInfo.totalItemCount === 0) return;
        setShowPageSizeOptionList(!showPageSizeOptionList);
    };

    const handlePageSizeChange = (option) => {
        setShowPageSizeOptionList(false);
        onPageSizeChange(option);
    };

    const showPageSizeOptions = () => {
        if (!pageInfo.pageSizeOptions) return false;

        if (pageInfo.pageSizeOptions.length === 0) return false;

        if (
            pageInfo.pageSizeOptions.length === 1 &&
            pageInfo.pageSizeOptions[0].text === 'All'
        )
            return false;

        return true;
    };

    return (
        <div>
            <div style={{ display: 'felx', justifyContent: 'space-between' }}>
                <span style={pageSizeLabel}>per page:</span>
                <span
                    id='pageSize'
                    style={
                        showPageSizeOptionList
                            ? pageSizeTextHighlight
                            : pageSizeText
                    }
                >
                    {getPageSizeText(pageInfo.pageSize)}
                </span>
                <IconChevronDown
                    id='togglePageSizePanel'
                    style={
                        showPageSizeOptions()
                            ? pageSizeIconActive
                            : pageSizeIconInactive
                    }
                    onClick={
                        showPageSizeOptions() ? handleClickDropdownButton : null
                    }
                />
            </div>
            <PageSizeOptionList
                invert={invert}
                invertShort={pageInfo.totalItemCount <= 30}
                visible={showPageSizeOptionList}
                options={pageInfo.pageSizeOptions}
                selectedPageSize={pageInfo.pageSize}
                onPageSizeChange={handlePageSizeChange}
            />
        </div>
    );
};

export default PageSizeSelect;
